import { render, staticRenderFns } from "./Pendentes.vue?vue&type=template&id=d46b1c96&scoped=true&"
import script from "./Pendentes.vue?vue&type=script&lang=js&"
export * from "./Pendentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d46b1c96",
  null
  
)

export default component.exports